<template>
    <details class="vchy-language-selector" v-bind:style="customStyle" v-vch-accordion ref="dropdown">
    <summary id="LANGUAGE_SELECTOR" ref="accordion">
      <h2 class="text-small-em">{{ selectedCountry }}</h2>
      <svg
        class="vchy-language-selector__toggle"
        aria-hidden="true"
        width="24"
        height="24"
      >
        <use href="/assets/sprite/icons.svg#arrow-black"></use>
      </svg>
    </summary>
    <div
      class="vchy-details__contents"
      :aria-labelledby="langSelectAriaLabel"
    >
      <ul class="vchy-language-selector__list pt-xs">
        <li v-for="country in countriesList"
            v-if="country.LanguageCode!=selectedCountry"
            :value="country.LanguageCode"
            :key="country.LanguageCode">
          <a :href="country.Url" class="text-small-em vchy-language-selector__link"> {{ country.LanguageCode }}</a>
        </li>
      </ul>
    </div>
  </details>


</template>

<script>
export default {
props: {
  countriesList : {
      type: Array,
      required: true,
    }, 
  baseUrl : {
      type: String,
      required: true,
    },
  defaultOption: {
      type: String,
      required: true,
    },
    customStyle: {
      type: Object,
      default: {
        width: '84px',
        height: '38px'
      }
    },
    langSelectAriaLabel: {
      type: String,
      required: false,
      default: 'Language Selector'
    },
},

  data() {
    return {
      selectedCountry: this.defaultOption,
    };
  },
 
  methods: {
    handleClickOutside(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.$refs.dropdown.removeAttribute('open');
      }
    }
  },

  mounted () {
    document.addEventListener('click',  this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" src="./language-selector.scss"></style>
